import type { SiteCopy } from '@/lib/content';
import copy from './site-copy.json';

/**
 * The site's editable words and photographs: hero headlines and paragraph, the
 * story section, the collection time, and the two photographs with their
 * measured sizes. Edited through the CMS (content/site.json) and validated into
 * site-copy.json by scripts/build-content.mjs at build.
 *
 * PLACEHOLDER: the hero paragraph, the story copy and the collection time in
 * content/site.json are written stand-ins for the owners' own words and facts.
 */
export const SITE_COPY: SiteCopy = copy as SiteCopy;
